module.exports = __webpack_public_path__ + "img/Mask Group 2917@2x.b445834b.png";